import React, { useState, useRef, useEffect } from "react";
import { FiSettings } from "react-icons/fi";
import "./SettingsButton.scss"; // Import the SCSS file

const SettingsButton = ({ options, onOptionChange }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [isScaling, setIsScaling] = useState(false);
  const settingsRef = useRef(null);

  const toggleOptions = () => {
    setIsScaling(true);
    setShowOptions(!showOptions);
    setTimeout(() => setIsScaling(false), 300); // Reset after animation
  };

  const handleOptionChange = (option) => {
    onOptionChange(option);
  };

  const handleClickOutside = (event) => {
    if (settingsRef.current && !settingsRef.current.contains(event.target)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="settings-button" ref={settingsRef}>
      <button onClick={toggleOptions} className="setter-button">
        <FiSettings
          className={`settings-icon ${isScaling ? "scale-up" : "scale-down"}`}
        />
      </button>

      {showOptions && (
        <div className="options-dropdown">
          {options.map((option) => (
            <label key={option.label}>
              <input
                type="checkbox"
                checked={option.checked}
                onChange={() => handleOptionChange(option.label)}
              />
              {option.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default SettingsButton;
